import { Suspense } from "react";
import PropTypes from "prop-types";

import LazyLoadTxt from "./LazyLoadTxt";

function LazyLoader(props) {
  const txt = props.txt || "Ladataan...";
  return <Suspense fallback={<LazyLoadTxt txt={txt} />}>{props.children}</Suspense>;
}

export default LazyLoader;

LazyLoader.propTypes = {
  WrappedComponent: PropTypes.func,
  txt: PropTypes.string,
  children: PropTypes.node,
};
